module.exports = __webpack_public_path__ + "static/media/billboard-en-futurecom.f778df5a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/billboard-en-futurecom.png
 ** module id = 444
 ** module chunks = 0
 **/